import archiveTabs from './archive-tab-navigation'

/**
 * Atoms loader.
 * @constructor
 */
export default function molecules () {
  archiveTabs()
}
